// Import package
import { v4 } from "uuid";

// Import file
import { baseRequest } from "../../util/Api";
import {
    setErrorMessage,
    setSuccessMessage,
    setLoadingMessage,
} from "./Common";
import { message } from "antd";

export const affiliateChecker = ({ code, training_id }) => (dispatch) =>
    new Promise((resolve) => {
        const messageKey = v4()
        dispatch(setLoadingMessage("Menambah kode affiliate ...", messageKey))
        baseRequest("post", "/affiliate/affiliate-checker", null, { code, training_id })
            .then((newData) => {
                dispatch(setSuccessMessage("Berhasil mendapatkan diskon 5%", messageKey))
                resolve(newData)
            })
            .catch((e) => {
                dispatch(setErrorMessage(e, messageKey))
            })
    })

export const affiliateChecker2 = ({ code, training_id }) =>
    new Promise((resolve) => {
        const messageKey = v4()
        message.open({ messageKey, type: 'loading', content: "Menambah kode affiliate ..." })
        baseRequest("post", "/affiliate/affiliate-checker", null, { code, training_id })
            .then((newData) => {
                message.open({ messageKey, type: 'success', content: "Berhasil mendapatkan diskon 5%" })
                resolve(newData)
            })
            .catch((e) => {
                message.open({ messageKey, type: 'error', content: e })
            })
    })

export const daftarAffiliateChecker = ({ code, training_id }) =>
    new Promise((resolve) => {
        const messageKey = v4()
        message.open({ messageKey, type: 'loading', content: "Menambah kode affiliate ..." })
        baseRequest("post", "/public/daftar/affiliate-checker", null, { code, training_id })
            .then((newData) => {
                message.open({ messageKey, type: 'success', content: "Berhasil mendapatkan diskon 5%" })
                resolve(newData)
            })
            .catch((e) => {
                message.open({ messageKey, type: 'error', content: e })
            })
    })